import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import OutboundBylineSsrStateQuery, {
	type preloadOutboundBylineSsrStateQuery$data,
	type preloadOutboundBylineSsrStateQuery$variables,
} from './__generated__/preloadOutboundBylineSsrStateQuery.graphql.ts';
import {
	normalizeOutboundBylineSsrState,
	type OutboundBylineSsrState,
} from './outboundBylineSsrState.ts';

export const useOutboundBylineSsrState = (
	contentId: string | undefined,
): OutboundBylineSsrState | undefined => {
	const { data } = useQueryInterop<
		preloadOutboundBylineSsrStateQuery$data,
		preloadOutboundBylineSsrStateQuery$variables
	>(OutboundBylineSsrStateQuery, {
		variables: { contentId: contentId ?? '' },
		fetchPolicy: 'cache-only',
		skip: contentId === undefined,
	});

	if (contentId === undefined || data === undefined) {
		return undefined;
	}

	return normalizeOutboundBylineSsrState(contentId, data);
};
